export default __webpack_public_path__ + "static/media/pr_c_04.9989c8b0.jpg";